/**
 * Translucent fill so page color shows through the grain.
 * Avoid opaque `bg-light` / solid white — that reads as a flat white panel on tan.
 */
export const CARD_TEXTURE_SURFACE =
  "card-texture-surface bg-tan/48 dark:bg-background-dark/46";
